var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 270,
    viewBox: "0 0 358 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8887 136.744L48.6378 141.321L68.6472 146.366L86.9104 151.876L103.432 157.849L118.211 164.286L131.246 171.192L137.587 175.326L137.611 175.34",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8887 136.744L48.6378 141.321L68.6472 146.366L86.9104 151.876L103.432 157.849L118.211 164.286L131.246 171.192L137.587 175.326L137.611 175.34",
    stroke: "url(#paint0_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141 123.593L51.583 130.348L71.0649 137.336L88.8723 144.56L104.995 152.021L119.437 159.716L132.194 167.648L140.53 173.795L140.727 173.94",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141 123.593L51.583 130.348L71.0649 137.336L88.8723 144.56L104.995 152.021L119.437 159.716L132.194 167.648L140.53 173.795L140.727 173.94",
    stroke: "url(#paint1_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.819 368.019L188.081 346.113L189.556 325.569L190.248 306.386L190.155 288.553L189.277 272.087L187.613 256.977L185.17 243.225L181.94 230.836L177.923 219.803L173.121 210.126L167.537 201.814L165.459 201.649L163.635 201.16L160.433 197.969L159.07 196.612L156.529 194.082L154.729 193.133",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M185.819 368.019L188.081 346.113L189.556 325.569L190.248 306.386L190.155 288.553L189.277 272.087L187.613 256.977L185.17 243.225L181.94 230.836L177.923 219.803L173.121 210.126L167.537 201.814L165.459 201.649L163.635 201.16L160.433 197.969L159.07 196.612L156.529 194.082L154.729 193.133",
    stroke: "url(#paint2_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4092 149.083L48.2381 151.621L68.3173 154.841L86.642 158.736L103.219 163.318L118.042 168.574L131.115 174.512L134.403 176.429",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4092 149.083L48.2381 151.621L68.3173 154.841L86.642 158.736L103.219 163.318L118.042 168.574L131.115 174.512L134.403 176.429",
    stroke: "url(#paint3_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M331.561 250.87L309.73 248.328L289.653 245.111L271.326 241.212L254.747 236.637L239.921 231.377L226.848 225.439L215.528 218.822L205.955 211.529L198.138 203.555L192.071 194.899L190.763 192.075L187.752 185.566L187.39 184.018",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M331.561 250.87L309.73 248.328L289.653 245.111L271.326 241.212L254.747 236.637L239.921 231.377L226.848 225.439L215.528 218.822L205.955 211.529L198.138 203.555L192.071 194.899L190.763 192.075L187.752 185.566L187.39 184.018",
    stroke: "url(#paint4_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M311.897 303.481L293.315 292.245L276.148 281.244L260.386 270.481L246.033 259.952L233.09 249.661L221.557 239.604L211.432 229.782L202.718 220.199L195.409 210.852L189.512 201.737L185.023 192.863L181.946 184.222L183.461 181.988L184.524 179.751L185.104 177.584L185.183 175.551",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M311.897 303.481L293.315 292.245L276.148 281.244L260.386 270.481L246.033 259.952L233.09 249.661L221.557 239.604L211.432 229.782L202.718 220.199L195.409 210.852L189.512 201.737L185.023 192.863L181.946 184.222L183.461 181.988L184.524 179.751L185.104 177.584L185.183 175.551",
    stroke: "url(#paint5_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M328.98 239.717L307.574 239.019L287.88 237.452L269.888 235.008L253.606 231.691L239.028 227.503L237.095 224.154L234.187 221.443L230.394 219.442",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M328.98 239.717L307.574 239.019L287.88 237.452L269.888 235.008L253.606 231.691L239.028 227.503L237.095 224.154L234.187 221.443L230.394 219.442",
    stroke: "url(#paint6_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9854 160.233L50.3911 160.931L70.0855 162.499L88.077 164.942L104.364 168.257L118.941 172.445L120.874 175.794L123.779 178.507L125.275 179.293",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9854 160.233L50.3911 160.931L70.0855 162.499L88.077 164.942L104.364 168.257L118.941 172.445L120.874 175.794L123.779 178.507L125.275 179.293",
    stroke: "url(#paint7_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M300.237 316.629L283.582 303.221L268.139 290.275L253.9 277.793L240.865 265.778L229.039 254.23L218.415 243.143L209.001 232.524L200.793 222.364L193.79 212.673L187.995 203.446L183.404 194.685L180.023 186.39L177.844 178.558L176.872 171.188L177.11 164.286L178.55 157.846L183.718 152.019L187.518 146.419L187.796 146.006",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M300.237 316.629L283.582 303.221L268.139 290.275L253.9 277.793L240.865 265.778L229.039 254.23L218.415 243.143L209.001 232.524L200.793 222.364L193.79 212.673L187.995 203.446L183.404 194.685L180.023 186.39L177.844 178.558L176.872 171.188L177.11 164.286L178.55 157.846L183.718 152.019L187.518 146.419L187.796 146.006",
    stroke: "url(#paint8_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M286.465 328.969L272.092 313.519L258.68 298.749L246.238 284.662L234.763 271.245L224.255 258.517L214.711 246.463L206.136 235.091L198.523 224.399L191.883 214.387L186.202 205.051L181.497 196.398L177.752 188.422L174.979 181.125L173.168 174.508L172.326 168.574L172.448 163.313L173.537 158.741L181.199 151.872L182.786 150.08L185.051 147.526L187.685 144.56",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M286.465 328.969L272.092 313.519L258.68 298.749L246.238 284.662L234.763 271.245L224.255 258.517L214.711 246.463L206.136 235.091L198.523 224.399L191.883 214.387L186.202 205.051L181.497 196.398L177.752 188.422L174.979 181.125L173.168 174.508L172.326 168.574L172.448 163.313L173.537 158.741L181.199 151.872L182.786 150.08L185.051 147.526L187.685 144.56",
    stroke: "url(#paint9_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M323.422 230.09L302.937 230.988L284.062 230.839L266.796 229.653L252.67 227.643L251.142 227.424L238.319 224.441L237.095 224.154L228.377 221.133L225.637 220.185L224.658 219.847L216.921 216.023L214.618 214.882L213.836 214.495L210.199 211.974L205.22 208.347L204.289 207.536L203.443 206.955",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M323.422 230.09L302.937 230.988L284.062 230.839L266.796 229.653L252.67 227.643L251.142 227.424L238.319 224.441L237.095 224.154L228.377 221.133L225.637 220.185L224.658 219.847L216.921 216.023L214.618 214.882L213.836 214.495L210.199 211.974L205.22 208.347L204.289 207.536L203.443 206.955",
    stroke: "url(#paint10_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.542 169.86L55.0288 168.966L73.9018 169.111L79.6499 174.47L87.1544 178.423L96.1826 180.845L106.469 181.66L113.875 181.124L117.623 180.653L120.691 180.16L120.972 180.089L121.202 180.096L121.309 180.104",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.542 169.86L55.0288 168.966L73.9018 169.111L79.6499 174.47L87.1544 178.423L96.1826 180.845L106.469 181.66L113.875 181.124L117.623 180.653L120.691 180.16L120.972 180.089L121.202 180.096L121.309 180.104",
    stroke: "url(#paint11_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M315.052 222.279L295.952 224.467L278.314 225.474L264.3 225.333L262.141 225.306L249.237 224.128L247.43 223.967L235.693 221.728L234.185 221.443L225.089 218.587L222.406 217.746L218.556 215.927L214.403 213.963L213.143 213.298L211.803 212.605L211.477 212.45",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M315.052 222.279L295.952 224.467L278.314 225.474L264.3 225.333L262.141 225.306L249.237 224.128L247.43 223.967L235.693 221.728L234.185 221.443L225.089 218.587L222.406 217.746L218.556 215.927L214.403 213.963L213.143 213.298L211.803 212.605L211.477 212.45",
    stroke: "url(#paint12_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9121 177.666L62.0143 175.481L79.6506 174.47L93.6623 174.617L95.8255 174.642L101.903 177.844L113.143 178.42L115.374 178.534L120.942 180.026L121.122 180.078L121.203 180.096L121.287 180.112",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9121 177.666L62.0143 175.481L79.6506 174.47L93.6623 174.617L95.8255 174.642L101.903 177.844L113.143 178.42L115.374 178.534L120.942 180.026L121.122 180.078L121.203 180.096L121.287 180.112",
    stroke: "url(#paint13_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M304.13 216.528L286.834 219.663L270.812 221.526L256.066 222.109L244.82 221.531L242.589 221.416L235.592 220.288L234.575 220.117L233.76 219.991L230.392 219.443L226.729 218.355",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M304.13 216.528L286.834 219.663L270.812 221.526L256.066 222.109L244.82 221.531L242.589 221.416L235.592 220.288L234.575 220.117L233.76 219.991L230.392 219.443L226.729 218.355",
    stroke: "url(#paint14_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8379 183.42L71.134 180.285L87.1556 178.422L101.903 177.844L109.217 179.8L118.201 180.024L120.712 180.083",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8379 183.42L71.134 180.285L87.1556 178.422L101.903 177.844L109.217 179.8L118.201 180.024L120.712 180.083",
    stroke: "url(#paint15_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3096 186.946L115.526 183.422L124.248 180.567L124.279 180.555L126.485 179.835L126.587 179.798L131.242 178.276L132.612 177.829L133.094 177.668L136.495 176.14L137.881 175.517L138.701 175.151L141.587 174.473L145.645 172.652L147.775 171.696L153.53 169.11L155.665 170.295L158.208 172.523L161.161 175.794L164.519 180.104L168.284 185.452L172.46 191.847L177.04 199.278L182.031 207.755L187.426 217.266L193.232 227.825L199.442 239.418L206.062 252.058L213.09 265.738L220.523 280.455L228.365 296.216L236.616 313.02L245.273 330.862L254.339 349.747",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3096 186.946L115.526 183.422L124.248 180.567L124.279 180.555L126.485 179.835L126.587 179.798L131.242 178.276L132.612 177.829L133.094 177.668L136.495 176.14L137.881 175.517L138.701 175.151L141.587 174.473L145.645 172.652L147.775 171.696L153.53 169.11L155.665 170.295L158.208 172.523L161.161 175.794L164.519 180.104L168.284 185.452L172.46 191.847L177.04 199.278L182.031 207.755L187.426 217.266L193.232 227.825L199.442 239.418L206.062 252.058L213.09 265.738L220.523 280.455L228.365 296.216L236.616 313.02L245.273 330.862L254.339 349.747",
    stroke: "url(#paint16_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M290.979 213.004L275.857 216.722L261.78 219.105L251.867 219.896L248.747 220.15L239.763 219.927L236.631 219.639L235.658 219.535L233.689 219.393L233.607 219.381",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M290.979 213.004L275.857 216.722L261.78 219.105L251.867 219.896L248.747 220.15L239.763 219.927L236.631 219.639L235.658 219.535L233.689 219.393L233.607 219.381",
    stroke: "url(#paint17_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9883 186.944L82.1105 183.226L96.1831 180.845L106.1 180.052L109.216 179.8L117.547 180.465",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9883 186.944L82.1105 183.226L96.1831 180.845L106.1 180.052L109.216 179.8L117.547 180.465",
    stroke: "url(#paint18_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M167.068 259.517L166.82 259.795L166.555 260.238L164.909 262.617L162.756 265.784L158.588 271.93L150.445 280.924L145.052 292.242L142.111 303.22L141.712 313.519L143.863 322.829L132.843 340.12",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M167.068 259.517L166.82 259.795L166.555 260.238L164.909 262.617L162.756 265.784L158.588 271.93L150.445 280.924L145.052 292.242L142.111 303.22L141.712 313.519L143.863 322.829L132.843 340.12",
    stroke: "url(#paint19_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M183.169 147.543L185.165 134.211L188.826 119.492L194.094 103.732L200.974 86.9295L209.464 69.09L219.562 50.2032",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M183.169 147.543L185.165 134.211L188.826 119.492L194.094 103.732L200.974 86.9295L209.464 69.09L219.562 50.2032",
    stroke: "url(#paint20_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M276.002 211.818L263.358 215.734L251.493 218.291L244.087 218.827L240.272 219.106",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M276.002 211.818L263.358 215.734L251.493 218.291L244.087 218.827L240.272 219.106",
    stroke: "url(#paint21_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9619 188.132L94.6102 184.214L106.471 181.66L114.868 180.755L117.548 180.465",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9619 188.132L94.6102 184.214L106.471 181.66L114.868 180.755L117.548 180.465",
    stroke: "url(#paint22_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M172.658 155.923L170.351 142.974L168.687 127.864L167.813 111.395L167.719 93.5681L168.408 74.3809L169.887 53.8351L172.145 31.9312",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M172.658 155.923L170.351 142.974L168.687 127.864L167.813 111.395L167.719 93.5681L168.408 74.3809L169.887 53.8351L172.145 31.9312",
    stroke: "url(#paint23_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M143.998 172.469L133.933 163.999L121.679 155.003L107.858 146.01L92.4624 137.017L75.5013 128.02L56.9727 119.026L36.8701 110.032",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M143.998 172.469L133.933 163.999L121.679 155.003L107.858 146.01L92.4624 137.017L75.5013 128.02L56.9727 119.026L36.8701 110.032",
    stroke: "url(#paint24_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M193.062 137.334L195.209 134.166L199.376 128.02L203.814 118.704L212.917 107.705L223.697 96.4682",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M193.062 137.334L195.209 134.166L199.376 128.02L203.814 118.704L212.917 107.705L223.697 96.4682",
    stroke: "url(#paint25_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M165.163 262.938L163.572 265.114L158.588 271.93L154.15 281.246L145.051 292.243L134.271 303.48",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M165.163 262.938L163.572 265.114L158.588 271.93L154.15 281.246L145.051 292.243L134.271 303.48",
    stroke: "url(#paint26_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M172.8 224.647L172.88 225.669L173.113 226.883L173.769 233.006L174.133 237.416L174.077 238.287L173.91 240.855L173.354 249.467L172.612 253.329L170.869 262.389L170.505 263.593L166.677 276.189L166.102 277.622L160.776 290.863L153.171 306.408L143.862 322.829L148.499 330.861L155.486 337.379L164.605 342.183L175.583 345.125L188.081 346.113L201.723 345.125L216.099 342.182L230.762 337.38L245.272 330.862L259.191 322.826L272.091 313.519L283.581 303.221L293.314 292.245L300.994 280.923L306.388 269.604L309.329 258.627L309.728 248.328L307.573 239.02L302.936 230.988L295.952 224.468L286.833 219.663L275.856 216.722L263.357 215.734L249.712 216.724L237.383 219.248L236.503 219.428",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M172.8 224.647L172.88 225.669L173.113 226.883L173.769 233.006L174.133 237.416L174.077 238.287L173.91 240.855L173.354 249.467L172.612 253.329L170.869 262.389L170.505 263.593L166.677 276.189L166.102 277.622L160.776 290.863L153.171 306.408L143.862 322.829L148.499 330.861L155.486 337.379L164.605 342.183L175.583 345.125L188.081 346.113L201.723 345.125L216.099 342.182L230.762 337.38L245.272 330.862L259.191 322.826L272.091 313.519L283.581 303.221L293.314 292.245L300.994 280.923L306.388 269.604L309.329 258.627L309.728 248.328L307.573 239.02L302.936 230.988L295.952 224.468L286.833 219.663L275.856 216.722L263.357 215.734L249.712 216.724L237.383 219.248L236.503 219.428",
    stroke: "url(#paint27_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M184.426 165.596L184.478 168.188L184.82 174.132L185.104 177.584L186.025 181.05L186.522 182.906L187.685 187.275L189.617 191.403L192.004 196.505L198.071 205.264L205.876 213.561L215.427 221.394L226.72 228.763L239.757 235.662L254.534 242.105L271.059 248.076L289.32 253.582L309.33 258.627L331.079 263.204",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M184.426 165.596L184.478 168.188L184.82 174.132L185.104 177.584L186.025 181.05L186.522 182.906L187.685 187.275L189.617 191.403L192.004 196.505L198.071 205.264L205.876 213.561L215.427 221.394L226.72 228.763L239.757 235.662L254.534 242.105L271.059 248.076L289.32 253.582L309.33 258.627L331.079 263.204",
    stroke: "url(#paint28_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M126.644 179.803L129.772 179.163L130.529 179.005L136.22 177.842L142.717 178.534L149.015 180.507L155.107 183.754L161.004 188.281L164.663 187.081L168.285 185.452L171.758 183.447L174.979 181.125L177.844 178.558L180.275 175.816L182.19 172.991L183.536 170.167L184.27 167.428",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M126.644 179.803L129.772 179.163L130.529 179.005L136.22 177.842L142.717 178.534L149.015 180.507L155.107 183.754L161.004 188.281L164.663 187.081L168.285 185.452L171.758 183.447L174.979 181.125L177.844 178.558L180.275 175.816L182.19 172.991L183.536 170.167L184.27 167.428",
    stroke: "url(#paint29_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M185.167 175.302L185.192 175.4L185.422 176.395L187.307 183.829L187.751 185.566L187.685 187.275L187.196 189.099L186.3 190.982L190.707 199.973L196.686 208.97L204.232 217.965L213.346 226.958L224.03 235.952L236.284 244.947L250.109 253.939L265.503 262.938L282.462 271.931L300.994 280.923L321.093 289.919",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M185.167 175.302L185.192 175.4L185.422 176.395L187.307 183.829L187.751 185.566L187.685 187.275L187.196 189.099L186.3 190.982L190.707 199.973L196.686 208.97L204.232 217.965L213.346 226.958L224.03 235.952L236.284 244.947L250.109 253.939L265.503 262.938L282.462 271.931L300.994 280.923L321.093 289.919",
    stroke: "url(#paint30_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 234.352L173.51 234.715L173.33 237.586L173.01 242.224L172.66 246.467L172.047 249.212L169.973 258.517L169.47 259.963L165.536 271.25L164.776 272.892L159.344 284.657L158.284 286.543L151.403 298.747L153.172 306.408L156.99 313.021L162.741 318.384L170.243 322.332L179.271 324.755L189.558 325.569L200.785 324.756L212.61 322.334L224.675 318.383L236.617 313.02L248.069 306.408L258.681 298.749L268.14 290.274L276.149 281.244L282.463 271.93L286.901 262.614L289.321 253.582L289.653 245.111L287.88 237.452L284.062 230.839L278.315 225.474L270.813 221.526L261.781 219.105L251.494 218.291L243.1 219.199L240.345 219.295L237.394 219.441",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 234.352L173.51 234.715L173.33 237.586L173.01 242.224L172.66 246.467L172.047 249.212L169.973 258.517L169.47 259.963L165.536 271.25L164.776 272.892L159.344 284.657L158.284 286.543L151.403 298.747L153.172 306.408L156.99 313.021L162.741 318.384L170.243 322.332L179.271 324.755L189.558 325.569L200.785 324.756L212.61 322.334L224.675 318.383L236.617 313.02L248.069 306.408L258.681 298.749L268.14 290.274L276.149 281.244L282.463 271.93L286.901 262.614L289.321 253.582L289.653 245.111L287.88 237.452L284.062 230.839L278.315 225.474L270.813 221.526L261.781 219.105L251.494 218.291L243.1 219.199L240.345 219.295L237.394 219.441",
    stroke: "url(#paint31_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M165.163 262.938L161.571 270.481L159.611 277.797L151.733 290.276L142.11 303.22L130.746 316.631",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M165.163 262.938L161.571 270.481L159.611 277.797L151.733 290.276L142.11 303.22L130.746 316.631",
    stroke: "url(#paint32_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M185.595 145.369L187.099 137.559L187.462 136.355L191.29 123.759L191.868 122.33L197.187 109.088L204.793 93.5422L214.104 77.1251L225.121 59.8301",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M185.595 145.369L187.099 137.559L187.462 136.355L191.29 123.759L191.868 122.33L197.187 109.088L204.793 93.5422L214.104 77.1251L225.121 59.8301",
    stroke: "url(#paint33_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M128.386 178.399L120.875 175.794L119.65 175.507L106.828 172.524L105.301 172.309L91.1694 170.297L73.9037 169.111L70.0858 162.498L68.3191 154.841L68.6484 146.366L71.0646 137.336L75.5024 128.02L81.8229 118.708L89.83 109.673L99.2841 101.201L109.9 93.5403L121.353 86.9282L133.291 81.567L145.36 77.6134L157.187 75.1961L168.408 74.3808L178.695 75.1956L187.727 77.6158L195.231 81.5682L200.975 86.9292L204.793 93.542L206.564 101.197L206.235 109.672L203.815 118.705L198.173 126.894L196.393 129.469L192.932 137.174L191.267 139.688L190.896 140.106L190.594 140.114L189.481 141.369L188.445 142.542L187.924 143.203L187.497 143.664L187.25 143.887",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M128.386 178.399L120.875 175.794L119.65 175.507L106.828 172.524L105.301 172.309L91.1694 170.297L73.9037 169.111L70.0858 162.498L68.3191 154.841L68.6484 146.366L71.0646 137.336L75.5024 128.02L81.8229 118.708L89.83 109.673L99.2841 101.201L109.9 93.5403L121.353 86.9282L133.291 81.567L145.36 77.6134L157.187 75.1961L168.408 74.3808L178.695 75.1956L187.727 77.6158L195.231 81.5682L200.975 86.9292L204.793 93.542L206.564 101.197L206.235 109.672L203.815 118.705L198.173 126.894L196.393 129.469L192.932 137.174L191.267 139.688L190.896 140.106L190.594 140.114L189.481 141.369L188.445 142.542L187.924 143.203L187.497 143.664L187.25 143.887",
    stroke: "url(#paint34_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M122.977 179.764L122.373 179.667L115.374 178.534L110.534 175.988L106.826 172.524L104.363 168.257L103.22 163.318L103.431 157.85L104.993 152.021L107.857 146.01L111.935 139.997L117.103 134.171L123.204 128.703L130.054 123.76L137.444 119.493L145.15 116.033L152.936 113.483L160.566 111.92L167.812 111.395L174.446 111.923L180.274 113.484L185.116 116.035L188.826 119.492L191.29 123.76L192.431 128.705L192.217 134.169L190.729 139.735L190.679 139.919L190.655 139.998L190.626 140.079",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M122.977 179.764L122.373 179.667L115.374 178.534L110.534 175.988L106.826 172.524L104.363 168.257L103.22 163.318L103.431 157.85L104.993 152.021L107.857 146.01L111.935 139.997L117.103 134.171L123.204 128.703L130.054 123.76L137.444 119.493L145.15 116.033L152.936 113.483L160.566 111.92L167.812 111.395L174.446 111.923L180.274 113.484L185.116 116.035L188.826 119.492L191.29 123.76L192.431 128.705L192.217 134.169L190.729 139.735L190.679 139.919L190.655 139.998L190.626 140.079",
    stroke: "url(#paint35_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M127.842 180.621L128.338 180.587L135.088 180.096L142.718 178.533L150.503 175.983L155.12 178.508L161.161 175.794L166.956 172.448L172.327 168.574L177.111 164.286L181.162 159.717L184.357 155.004L186.604 150.289",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M127.842 180.621L128.338 180.587L135.088 180.096L142.718 178.533L150.503 175.983L155.12 178.508L161.161 175.794L166.956 172.448L172.327 168.574L177.111 164.286L181.162 159.717L184.357 155.004L186.604 150.289",
    stroke: "url(#paint36_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M167.309 259.953L167.287 260.036L167.155 260.3L165.87 262.589L161.572 270.481L159.796 273.054L154.151 281.246L151.734 290.276L151.403 298.747L141.712 313.519L130.266 328.966",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M167.309 259.953L167.287 260.036L167.155 260.3L165.87 262.589L161.572 270.481L159.796 273.054L154.151 281.246L151.734 290.276L151.403 298.747L141.712 313.519L130.266 328.966",
    stroke: "url(#paint37_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M136.495 176.141L141.494 174.506L141.588 174.474L145.995 174.643L155.665 170.295L164.942 164.94L173.538 158.741L175.595 154.84L175.67 154.775L179.585 151.263",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M136.495 176.141L141.494 174.506L141.588 174.474L145.995 174.643L155.665 170.295L164.942 164.94L173.538 158.741L175.595 154.84L175.67 154.775L179.585 151.263",
    stroke: "url(#paint38_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M132.146 181.73L137.35 182.143L143.029 181.733L149.015 180.507L155.12 178.508L159.839 182.205L164.664 187.081L169.592 193.133L174.631 200.362L179.768 208.766L185.017 218.351L190.364 229.11L195.821 241.047L201.382 254.159L207.049 268.452L212.818 283.916L218.695 300.564L224.674 318.383L230.764 337.38L236.953 357.555",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M132.146 181.73L137.35 182.143L143.029 181.733L149.015 180.507L155.12 178.508L159.839 182.205L164.664 187.081L169.592 193.133L174.631 200.362L179.768 208.766L185.017 218.351L190.364 229.11L195.821 241.047L201.382 254.159L207.049 268.452L212.818 283.916L218.695 300.564L224.674 318.383L230.764 337.38L236.953 357.555",
    stroke: "url(#paint39_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M131.241 178.276L131.865 178.222L132.069 178.201L136.218 177.842L145.993 174.643L150.502 175.984L158.207 172.523L165.598 168.256L172.448 163.313L178.549 157.846L181.198 151.873L183.585 148.458L184.059 147.782",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M131.241 178.276L131.865 178.222L132.069 178.201L136.218 177.842L145.993 174.643L150.502 175.984L158.207 172.523L165.598 168.256L172.448 163.313L178.549 157.846L181.198 151.873L183.585 148.458L184.059 147.782",
    stroke: "url(#paint40_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M170.14 254.229L169.972 258.517L170.87 262.389L172.803 265.737L169.142 280.456L163.87 296.218L156.99 313.021L148.5 330.86L138.401 349.747",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M170.14 254.229L169.972 258.517L170.87 262.389L172.803 265.737L169.142 280.456L163.87 296.218L156.99 313.021L148.5 330.86L138.401 349.747",
    stroke: "url(#paint41_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M160.389 164.006L158.527 160.53L151.906 147.89L144.879 134.21L137.445 119.493L129.603 103.732L121.352 86.9284L112.695 69.0861L103.629 50.201",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M160.389 164.006L158.527 160.53L151.906 147.89L144.879 134.21L137.445 119.493L129.603 103.732L121.352 86.9284L112.695 69.0861L103.629 50.201",
    stroke: "url(#paint42_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M157.132 165.885L155.053 162.535L147.417 150.481L139.084 137.556L130.054 123.759L120.326 109.088L109.9 93.5404L98.7762 77.1219L86.9541 59.8281",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M157.132 165.885L155.053 162.535L147.417 150.481L139.084 137.556L130.054 123.759L120.326 109.088L109.9 93.5404L98.7762 77.1219L86.9541 59.8281",
    stroke: "url(#paint43_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M180.884 149.594L180.864 145.791L182.257 131.5L185.117 116.035L189.442 99.3856L195.231 81.5684L202.482 62.569L211.198 42.3956",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M180.884 149.594L180.864 145.791L182.257 131.5L185.117 116.035L189.442 99.3856L195.231 81.5684L202.482 62.569L211.198 42.3956",
    stroke: "url(#paint44_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M189.546 142.868L189.49 142.965L188.976 144.272L186.941 149.439L186.869 149.733L186.287 152.159L185.178 156.808L185.016 158.696L184.427 165.596L184.27 167.428L184.479 168.189L185.168 175.302L185.183 175.551L185.424 176.396L187.39 184.018L187.776 184.854L191.43 192.792L197.006 200.673L197.606 201.256L203.443 206.955L204.617 208.105L205.22 208.348L211.478 212.45L212.091 212.87L213.145 213.299L214.368 213.807L219.464 216.194L221.347 216.757L223.189 217.305L226.73 218.356L228.953 218.689L233.608 219.381L233.723 219.385L235.658 219.535L236.632 219.64L237.394 219.442L240.345 219.296L249.714 216.724L259.659 213.002L276.003 211.819L290.98 213.004L304.131 216.528L315.054 222.279L323.422 230.09L328.98 239.717L331.561 250.87L331.08 263.205L327.556 276.356L321.094 289.919L311.898 303.481L300.237 316.629L286.466 328.969L271.015 340.12L254.34 349.747L236.953 357.556L219.385 363.309L202.168 366.834L185.82 368.019L170.848 366.831L157.696 363.307L146.774 357.557L138.402 349.748L132.844 340.121L130.267 328.966L130.748 316.631L134.272 303.48L140.729 289.919L149.93 276.354L158.122 269.604L165.037 262.775L166.64 260.292L167.188 259.733L167.588 258.836L168.425 257.084L168.48 256.983L170.204 252.608L171.031 250.513L172.337 245.052L172.788 243.143L173.33 237.586L173.497 236.313L173.599 235.093L173.542 234.352L173.115 226.884L173.209 226.238L172.801 224.647L170.78 216.744L170.575 215.933L166.538 207.163L161.49 200.03L160.959 199.278L155.346 193.761L154.73 193.133L154.526 192.993L148.707 188.842L148.156 188.278L146.491 187.499L140.217 184.561L138.501 183.757L133.921 182.393L131.533 181.682L131.242 181.597L125.746 180.778L124.361 180.567L124.249 180.568",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M189.546 142.868L189.49 142.965L188.976 144.272L186.941 149.439L186.869 149.733L186.287 152.159L185.178 156.808L185.016 158.696L184.427 165.596L184.27 167.428L184.479 168.189L185.168 175.302L185.183 175.551L185.424 176.396L187.39 184.018L187.776 184.854L191.43 192.792L197.006 200.673L197.606 201.256L203.443 206.955L204.617 208.105L205.22 208.348L211.478 212.45L212.091 212.87L213.145 213.299L214.368 213.807L219.464 216.194L221.347 216.757L223.189 217.305L226.73 218.356L228.953 218.689L233.608 219.381L233.723 219.385L235.658 219.535L236.632 219.64L237.394 219.442L240.345 219.296L249.714 216.724L259.659 213.002L276.003 211.819L290.98 213.004L304.131 216.528L315.054 222.279L323.422 230.09L328.98 239.717L331.561 250.87L331.08 263.205L327.556 276.356L321.094 289.919L311.898 303.481L300.237 316.629L286.466 328.969L271.015 340.12L254.34 349.747L236.953 357.556L219.385 363.309L202.168 366.834L185.82 368.019L170.848 366.831L157.696 363.307L146.774 357.557L138.402 349.748L132.844 340.121L130.267 328.966L130.748 316.631L134.272 303.48L140.729 289.919L149.93 276.354L158.122 269.604L165.037 262.775L166.64 260.292L167.188 259.733L167.588 258.836L168.425 257.084L168.48 256.983L170.204 252.608L171.031 250.513L172.337 245.052L172.788 243.143L173.33 237.586L173.497 236.313L173.599 235.093L173.542 234.352L173.115 226.884L173.209 226.238L172.801 224.647L170.78 216.744L170.575 215.933L166.538 207.163L161.49 200.03L160.959 199.278L155.346 193.761L154.73 193.133L154.526 192.993L148.707 188.842L148.156 188.278L146.491 187.499L140.217 184.561L138.501 183.757L133.921 182.393L131.533 181.682L131.242 181.597L125.746 180.778L124.361 180.567L124.249 180.568",
    stroke: "url(#paint45_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M124.359 180.567L127.84 180.621L129.156 180.834L130.465 181.045L137.348 182.143L138.749 182.607L146.07 185.022L146.86 185.441L154.013 189.258L154.468 189.619L161.168 194.858L167.537 201.814L169.802 201.651L172.188 201.159L174.629 200.362L177.039 199.277L179.352 197.942L181.496 196.398L183.403 194.684L185.022 192.863L186.299 190.981L183.46 181.987L182.269 173.568L182.188 172.991L182.459 164.888L182.487 163.996L184.056 156.45L184.355 155.004L186.845 148.494L187.317 147.254L187.794 146.006L189.488 142.965",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M124.359 180.567L127.84 180.621L129.156 180.834L130.465 181.045L137.348 182.143L138.749 182.607L146.07 185.022L146.86 185.441L154.013 189.258L154.468 189.619L161.168 194.858L167.537 201.814L169.802 201.651L172.188 201.159L174.629 200.362L177.039 199.277L179.352 197.942L181.496 196.398L183.403 194.684L185.022 192.863L186.299 190.981L183.46 181.987L182.269 173.568L182.188 172.991L182.459 164.888L182.487 163.996L184.056 156.45L184.355 155.004L186.845 148.494L187.317 147.254L187.794 146.006L189.488 142.965",
    stroke: "url(#paint46_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M163.623 162.138L162.147 158.901L156.586 145.789L150.921 131.5L145.15 116.032L139.271 99.3909L133.289 81.5673L127.204 62.5678L121.011 42.395",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M163.623 162.138L162.147 158.901L156.586 145.789L150.921 131.5L145.15 116.032L139.271 99.3909L133.289 81.5673L127.204 62.5678L121.011 42.395",
    stroke: "url(#paint47_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M153.893 167.756L151.832 164.857L143.257 153.485L133.716 141.435L123.205 128.703L111.729 115.293L99.2839 101.201L85.8766 86.4291L71.499 70.9814",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M153.893 167.756L151.832 164.857L143.257 153.485L133.716 141.435L123.205 128.703L111.729 115.293L99.2839 101.201L85.8766 86.4291L71.499 70.9814",
    stroke: "url(#paint48_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M219.463 216.194L222.406 217.746L224.656 219.847L226.152 222.438L226.847 225.438L226.72 228.763L225.771 232.303L224.03 235.952L221.556 239.604L218.414 243.143L214.711 246.463L210.551 249.467L206.062 252.059L201.381 254.16L196.65 255.709L192.018 256.658L187.614 256.977L183.584 256.66L180.043 255.711L177.1 254.16L174.85 252.058L173.354 249.467L172.659 246.467L172.787 243.143",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M219.463 216.194L222.406 217.746L224.656 219.847L226.152 222.438L226.847 225.438L226.72 228.763L225.771 232.303L224.03 235.952L221.556 239.604L218.414 243.143L214.711 246.463L210.551 249.467L206.062 252.059L201.381 254.16L196.65 255.709L192.018 256.658L187.614 256.977L183.584 256.66L180.043 255.711L177.1 254.16L174.85 252.058L173.354 249.467L172.659 246.467L172.787 243.143",
    stroke: "url(#paint49_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M131.761 177.294L131.116 174.512L131.246 171.192L132.193 167.647L133.933 163.999L136.412 160.344L139.549 156.807L143.257 153.485L147.417 150.481L151.906 147.89L156.587 145.789L161.314 144.242L165.949 143.29L170.35 142.974L174.38 143.291L177.923 144.243L180.863 145.791L182.95 147.74",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M131.761 177.294L131.116 174.512L131.246 171.192L132.193 167.647L133.933 163.999L136.412 160.344L139.549 156.807L143.257 153.485L147.417 150.481L151.906 147.89L156.587 145.789L161.314 144.242L165.949 143.29L170.35 142.974L174.38 143.291L177.923 144.243L180.863 145.791L182.95 147.74",
    stroke: "url(#paint50_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M148.155 188.279L150.891 189.015L154.014 189.259L157.418 189.013L161.003 188.281L166.697 194.085L172.189 201.16L177.486 209.514L182.575 219.149L187.466 230.058L192.161 242.247L196.65 255.709L200.944 270.451L205.032 286.466L208.92 303.763L212.609 322.335L216.1 342.182L219.384 363.309",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M148.155 188.279L150.891 189.015L154.014 189.259L157.418 189.013L161.003 188.281L166.697 194.085L172.189 201.16L177.486 209.514L182.575 219.149L187.466 230.058L192.161 242.247L196.65 255.709L200.944 270.451L205.032 286.466L208.92 303.763L212.609 322.335L216.1 342.182L219.384 363.309",
    stroke: "url(#paint51_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M150.632 169.488L148.964 167.427L139.55 156.807L128.932 145.722L117.105 134.17L104.069 122.155L89.83 109.674L74.3871 96.727L57.7324 83.3193",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M150.632 169.488L148.964 167.427L139.55 156.807L128.932 145.722L117.105 134.17L104.069 122.155L89.83 109.674L74.3871 96.727L57.7324 83.3193",
    stroke: "url(#paint52_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M166.759 160.177L165.804 157.704L161.314 144.241L157.027 129.502L152.936 113.482L149.049 96.1855L145.359 77.6135L141.868 57.7662L138.584 36.6391",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M166.759 160.177L165.804 157.704L161.314 144.241L157.027 129.502L152.936 113.482L149.049 96.1855L145.359 77.6135L141.868 57.7662L138.584 36.6391",
    stroke: "url(#paint53_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M212.091 212.87L213.835 214.495L214.991 216.498L215.527 218.821L215.427 221.394L214.693 224.133L213.347 226.958L211.432 229.783L209.001 232.524L206.136 235.091L202.915 237.413L199.442 239.418L195.82 241.047L192.161 242.247L188.575 242.979L185.171 243.225L182.048 242.981L179.313 242.244L177.035 241.045L175.29 239.419L174.134 237.416L173.599 235.093",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M212.091 212.87L213.835 214.495L214.991 216.498L215.527 218.821L215.427 221.394L214.693 224.133L213.347 226.958L211.432 229.783L209.001 232.524L206.136 235.091L202.915 237.413L199.442 239.418L195.82 241.047L192.161 242.247L188.575 242.979L185.171 243.225L182.048 242.981L179.313 242.244L177.035 241.045L175.29 239.419L174.134 237.416L173.599 235.093",
    stroke: "url(#paint54_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M187.513 143.591L187.993 141.433L188.5 139.985L192.432 128.705L193.194 127.056L198.625 115.291L199.682 113.408L206.564 101.197L216.257 86.4292L227.7 70.9786",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M187.513 143.591L187.993 141.433L188.5 139.985L192.432 128.705L193.194 127.056L198.625 115.291L199.682 113.408L206.564 101.197L216.257 86.4292L227.7 70.9786",
    stroke: "url(#paint55_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M125.886 179.17L123.778 178.507L122.274 178.22L110.535 175.987L108.73 175.82L95.8256 174.641L91.1682 170.297L88.0762 164.942L86.6426 158.736L86.9105 151.876L88.8708 144.56L92.4624 137.017L97.5816 129.467L104.068 122.155L111.728 115.293L120.326 109.088L129.602 103.732L139.271 99.3906L149.048 96.1855L158.624 94.2244L167.718 93.568L176.046 94.2293L183.366 96.1873L189.441 99.3854L194.094 103.732L197.186 109.088L198.624 115.291L198.358 122.155L196.392 129.469L192.094 137.361L190.894 139.564L190.655 139.997L190.613 140.092",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M125.886 179.17L123.778 178.507L122.274 178.22L110.535 175.987L108.73 175.82L95.8256 174.641L91.1682 170.297L88.0762 164.942L86.6426 158.736L86.9105 151.876L88.8708 144.56L92.4624 137.017L97.5816 129.467L104.068 122.155L111.728 115.293L120.326 109.088L129.602 103.732L139.271 99.3906L149.048 96.1855L158.624 94.2244L167.718 93.568L176.046 94.2293L183.366 96.1873L189.441 99.3854L194.094 103.732L197.186 109.088L198.624 115.291L198.358 122.155L196.392 129.469L192.094 137.361L190.894 139.564L190.655 139.997L190.613 140.092",
    stroke: "url(#paint56_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M145.403 171.841L146.537 170.166L148.964 167.427L151.832 164.857L155.053 162.535L158.527 160.53L162.148 158.901L165.804 157.704L169.393 156.97L171.411 156.826",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M145.403 171.841L146.537 170.166L148.964 167.427L151.832 164.857L155.053 162.535L158.527 160.53L162.148 158.901L165.804 157.704L169.393 156.97L171.411 156.826",
    stroke: "url(#paint57_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M204.617 208.105L205.531 209.688L205.954 211.529L205.876 213.562L205.295 215.729L204.233 217.965L202.718 220.199L200.792 222.364L198.523 224.399L195.98 226.239L193.232 227.825L190.363 229.111L187.466 230.058L184.633 230.641L181.94 230.836L179.473 230.638L177.301 230.059L175.502 229.11L174.123 227.821L173.209 226.238",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M204.617 208.105L205.531 209.688L205.954 211.529L205.876 213.562L205.295 215.729L204.233 217.965L202.718 220.199L200.792 222.364L198.523 224.399L195.98 226.239L193.232 227.825L190.363 229.111L187.466 230.058L184.633 230.641L181.94 230.836L179.473 230.638L177.301 230.059L175.502 229.11L174.123 227.821L173.209 226.238",
    stroke: "url(#paint58_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M187.929 143.119L187.992 141.433L187.099 137.559L185.165 134.21L182.257 131.5L178.464 129.499L173.894 128.274L168.686 127.864L163.007 128.273L157.027 129.501L150.922 131.5L144.879 134.21L139.084 137.556L133.715 141.435L128.932 145.722L124.874 150.289L121.68 155.003L119.436 159.716L118.211 164.286L118.043 168.574L118.941 172.445L131.485 177.383",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M187.929 143.119L187.992 141.433L187.099 137.559L185.165 134.21L182.257 131.5L178.464 129.499L173.894 128.274L168.686 127.864L163.007 128.273L157.027 129.501L150.922 131.5L144.879 134.21L139.084 137.556L133.715 141.435L128.932 145.722L124.874 150.289L121.68 155.003L119.436 159.716L118.211 164.286L118.043 168.574L118.941 172.445L131.485 177.383",
    stroke: "url(#paint59_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M160.959 199.278L162.123 200.363L163.636 201.16L166.245 204.898L169.466 209.518L171.174 209.972L175.846 219.638L179.473 230.638L182.048 242.981L183.584 256.66L184.075 271.674L183.518 288.029L181.918 305.721L179.27 324.755L175.583 345.125L170.847 366.831",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M160.959 199.278L162.123 200.363L163.636 201.16L166.245 204.898L169.466 209.518L171.174 209.972L175.846 219.638L179.473 230.638L182.048 242.981L183.584 256.66L184.075 271.674L183.518 288.029L181.918 305.721L179.27 324.755L175.583 345.125L170.847 366.831",
    stroke: "url(#paint60_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M170.575 215.933L171.345 217.266L172.508 218.352L175.502 229.11L177.035 241.045L177.101 254.16L175.707 268.451L172.85 283.92L168.527 300.563L162.74 318.384L155.487 337.379L146.773 357.557",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M170.575 215.933L171.345 217.266L172.508 218.352L175.502 229.11L177.035 241.045L177.101 254.16L175.707 268.451L172.85 283.92L168.527 300.563L162.74 318.384L155.487 337.379L146.773 357.557",
    stroke: "url(#paint61_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M197.005 200.673L197.775 202.007L198.137 203.555L198.071 205.264L197.582 207.088L196.686 208.97L195.409 210.852L193.79 212.674L191.883 214.387L189.739 215.931L187.426 217.267L185.016 218.352L182.575 219.148L180.188 219.64L177.924 219.803L175.846 219.638L174.022 219.149L172.508 218.352L168.045 208.77L166.254 206.225L162.122 200.363L160.84 199.11L155.345 193.761L154.598 193.064L154.525 192.993",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M197.005 200.673L197.775 202.007L198.137 203.555L198.071 205.264L197.582 207.088L196.686 208.97L195.409 210.852L193.79 212.674L191.883 214.387L189.739 215.931L187.426 217.267L185.016 218.352L182.575 219.148L180.188 219.64L177.924 219.803L175.846 219.638L174.022 219.149L172.508 218.352L168.045 208.77L166.254 206.225L162.122 200.363L160.84 199.11L155.345 193.761L154.598 193.064L154.525 192.993",
    stroke: "url(#paint62_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M166.958 207.753L168.045 208.77L169.466 209.518L174.022 219.149L177.301 230.059L179.313 242.245L180.044 255.712L179.505 270.449L177.691 286.471L174.604 303.765L170.242 322.332L164.606 342.183L157.696 363.307",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M166.958 207.753L168.045 208.77L169.466 209.518L174.022 219.149L177.301 230.059L179.313 242.245L180.044 255.712L179.505 270.449L177.691 286.471L174.604 303.765L170.242 322.332L164.606 342.183L157.696 363.307",
    stroke: "url(#paint63_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M191.733 193.449L192.07 194.898L192.004 196.505L191.547 198.209L190.707 199.973L189.512 201.737L187.995 203.446L186.202 205.051L184.198 206.503L182.03 207.755L179.767 208.766L177.485 209.514L175.247 209.973L173.121 210.126L171.173 209.972L165.46 201.649L160.143 196.154L159.039 195.013L158.701 194.66L152.91 190.476L151.487 189.444L150.89 189.014L145.236 186.256L142.04 184.705L138.5 183.756",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M191.733 193.449L192.07 194.898L192.004 196.505L191.547 198.209L190.707 199.973L189.512 201.737L187.995 203.446L186.202 205.051L184.198 206.503L182.03 207.755L179.767 208.766L177.485 209.514L175.247 209.973L173.121 210.126L171.173 209.972L165.46 201.649L160.143 196.154L159.039 195.013L158.701 194.66L152.91 190.476L151.487 189.444L150.89 189.014L145.236 186.256L142.04 184.705L138.5 183.756",
    stroke: "url(#paint64_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M147.288 170.994L146.536 170.166L136.411 160.344L124.874 150.29L111.935 139.997L97.5818 129.468L81.822 118.708L64.6488 107.706L46.0732 96.4712",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M147.288 170.994L146.536 170.166L136.411 160.344L124.874 150.29L111.935 139.997L97.5818 129.468L81.822 118.708L64.6488 107.706L46.0732 96.4712",
    stroke: "url(#paint65_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M169.734 158.035L169.393 156.969L165.949 143.29L163.007 128.273L160.566 111.92L158.624 94.2246L157.186 75.1965L156.241 54.8253L155.803 33.1187",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M169.734 158.035L169.393 156.969L165.949 143.29L163.007 128.273L160.566 111.92L158.624 94.2246L157.186 75.1965L156.241 54.8253L155.803 33.1187",
    stroke: "url(#paint66_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M126.548 179.814L126.643 179.802L128.222 179.858L128.853 179.88L135.087 180.096L143.028 181.733L150.475 184.703L157.418 189.012L163.861 194.663L166.697 194.084L169.591 193.133L172.46 191.847L175.208 190.261L177.752 188.422L180.023 186.39L181.946 184.221L180.274 175.816L180.013 167.649L181.161 159.717L183.718 152.019L186.644 146.515L187.685 144.56L187.739 144.486",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M126.548 179.814L126.643 179.802L128.222 179.858L128.853 179.88L135.087 180.096L143.028 181.733L150.475 184.703L157.418 189.012L163.861 194.663L166.697 194.084L169.591 193.133L172.46 191.847L175.208 190.261L177.752 188.422L180.023 186.39L181.946 184.221L180.274 175.816L180.013 167.649L181.161 159.717L183.718 152.019L186.644 146.515L187.685 144.56L187.739 144.486",
    stroke: "url(#paint67_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M236.76 219.855L236.842 219.877L237.024 219.922L242.588 221.417L247.43 223.967L251.14 227.424L253.604 231.692L254.745 236.637L254.533 242.105L252.969 247.93L250.109 253.939L246.031 259.952L240.863 265.778L234.762 271.245L227.912 276.189L220.522 280.456L212.816 283.916L205.031 286.466L197.401 288.029L190.154 288.553L183.517 288.028L177.69 286.47L172.849 283.92L169.141 280.456L166.677 276.189L165.534 271.25L165.746 265.782L167.153 260.3L167.186 259.733L167.586 258.836L168.447 257.06L168.478 256.983",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M236.76 219.855L236.842 219.877L237.024 219.922L242.588 221.417L247.43 223.967L251.14 227.424L253.604 231.692L254.745 236.637L254.533 242.105L252.969 247.93L250.109 253.939L246.031 259.952L240.863 265.778L234.762 271.245L227.912 276.189L220.522 280.456L212.816 283.916L205.031 286.466L197.401 288.029L190.154 288.553L183.517 288.028L177.69 286.47L172.849 283.92L169.141 280.456L166.677 276.189L165.534 271.25L165.746 265.782L167.153 260.3L167.186 259.733L167.586 258.836L168.447 257.06L168.478 256.983",
    stroke: "url(#paint68_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M192.802 137.017L194.394 134.841L199.375 128.021L207.522 119.024L217.235 110.031",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M192.802 137.017L194.394 134.841L199.375 128.021L207.522 119.024L217.235 110.031",
    stroke: "url(#paint69_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M175.564 153.826L175.537 153.584L174.381 143.29L173.894 128.274L174.447 111.922L176.047 94.2294L178.695 75.1957L182.388 54.8276L187.122 33.117",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M175.564 153.826L175.537 153.584L174.381 143.29L173.894 128.274L174.447 111.922L176.047 94.2294L178.695 75.1957L182.388 54.8276L187.122 33.117",
    stroke: "url(#paint70_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M171.03 250.513L170.14 254.23L168.926 257.423L168.632 258.189L168.267 259.158L165.746 265.782L164.73 267.771L159.611 277.797L159.343 284.657L160.777 290.863L163.869 296.219L168.526 300.563L174.603 303.765L181.917 305.721L190.248 306.387L199.343 305.724L208.919 303.763L218.694 300.564L228.365 296.216L237.641 290.861L246.237 284.662L253.899 277.794L260.386 270.481L265.503 262.938L269.092 255.391L271.059 248.076L271.325 241.212L269.887 235.009L266.795 229.653L262.142 225.307L256.067 222.109L248.747 220.151L240.418 219.489",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M171.03 250.513L170.14 254.23L168.926 257.423L168.632 258.189L168.267 259.158L165.746 265.782L164.73 267.771L159.611 277.797L159.343 284.657L160.777 290.863L163.869 296.219L168.526 300.563L174.603 303.765L181.917 305.721L190.248 306.387L199.343 305.724L208.919 303.763L218.694 300.564L228.365 296.216L237.641 290.861L246.237 284.662L253.899 277.794L260.386 270.481L265.503 262.938L269.092 255.391L271.059 248.076L271.325 241.212L269.887 235.009L266.795 229.653L262.142 225.307L256.067 222.109L248.747 220.151L240.418 219.489",
    stroke: "url(#paint71_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M146.492 187.499L147.294 188.051L148.707 188.842L153.468 191.96L153.687 192.107L156.53 194.082L158.702 194.66L161.17 194.858L163.862 194.663L169.804 201.651L175.248 209.974L180.189 219.64L184.633 230.641L188.576 242.979L192.02 256.658L194.958 271.677L197.403 288.029L199.345 305.724L200.785 324.756L201.724 345.125L202.168 366.834",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M146.492 187.499L147.294 188.051L148.707 188.842L153.468 191.96L153.687 192.107L156.53 194.082L158.702 194.66L161.17 194.858L163.862 194.663L169.804 201.651L175.248 209.974L180.189 219.64L184.633 230.641L188.576 242.979L192.02 256.658L194.958 271.677L197.403 288.029L199.345 305.724L200.785 324.756L201.724 345.125L202.168 366.834",
    stroke: "url(#paint72_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M189.481 141.369L189.699 140.797L192.218 134.169L193.235 132.18L198.36 122.155L206.235 109.673L215.858 96.7286L227.222 83.3174",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M189.481 141.369L189.699 140.797L192.218 134.169L193.235 132.18L198.36 122.155L206.235 109.673L215.858 96.7286L227.222 83.3174",
    stroke: "url(#paint73_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M191.43 192.791L191.734 193.449L196.451 200.128L197.777 202.006L202.336 206.525L205.532 209.688L208.644 211.932L214.992 216.498L226.154 222.438L239.029 227.503L239.922 231.377L239.758 235.662L238.534 240.232L236.286 244.947L233.091 249.661L229.04 254.23L224.256 258.517L218.885 262.392L213.091 265.738L207.05 268.452L200.945 270.45L194.958 271.677L189.279 272.087L184.076 271.673L179.506 270.449L175.708 268.45L172.804 265.737L174.851 252.058L175.292 239.419L174.508 231.64L174.124 227.821L172.979 223.474L171.346 217.266L170.382 215.179L166.96 207.752L166.538 207.163",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M191.43 192.791L191.734 193.449L196.451 200.128L197.777 202.006L202.336 206.525L205.532 209.688L208.644 211.932L214.992 216.498L226.154 222.438L239.029 227.503L239.922 231.377L239.758 235.662L238.534 240.232L236.286 244.947L233.091 249.661L229.04 254.23L224.256 258.517L218.885 262.392L213.091 265.738L207.05 268.452L200.945 270.45L194.958 271.677L189.279 272.087L184.076 271.673L179.506 270.449L175.708 268.45L172.804 265.737L174.851 252.058L175.292 239.419L174.508 231.64L174.124 227.821L172.979 223.474L171.346 217.266L170.382 215.179L166.96 207.752L166.538 207.163",
    stroke: "url(#paint74_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M131.241 181.597L132.146 181.73L137.82 183.434L142.041 184.705L146.071 185.022L150.475 184.703L155.107 183.754L159.838 182.205L164.519 180.104L169.008 177.512L173.168 174.508L176.872 171.188L180.013 167.65L182.488 163.997L184.228 160.348L185.177 156.808",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M131.241 181.597L132.146 181.73L137.82 183.434L142.041 184.705L146.071 185.022L150.475 184.703L155.107 183.754L159.838 182.205L164.519 180.104L169.008 177.512L173.168 174.508L176.872 171.188L180.013 167.65L182.488 163.997L184.228 160.348L185.177 156.808",
    stroke: "url(#paint75_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M178.337 151.827L178.333 151.803L177.923 144.243L178.464 129.499L180.275 113.484L183.367 96.1873L187.727 77.6158L193.362 57.7648L200.273 36.6408",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M178.337 151.827L178.333 151.803L177.923 144.243L178.464 129.499L180.275 113.484L183.367 96.1873L187.727 77.6158L193.362 57.7648L200.273 36.6408",
    stroke: "url(#paint76_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M186.941 149.439L186.604 150.289L185.239 156.058L184.229 160.348L183.978 163.888L183.536 170.167L183.791 172.647L184.524 179.751L185.096 181.748L187.197 189.099L191.548 198.209L197.583 207.088L205.296 215.729L214.693 224.133L225.772 232.303L238.533 240.232L252.971 247.93L269.093 255.39L286.901 262.614L306.389 269.604L327.555 276.355",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M186.941 149.439L186.604 150.289L185.239 156.058L184.229 160.348L183.978 163.888L183.536 170.167L183.791 172.647L184.524 179.751L185.096 181.748L187.197 189.099L191.548 198.209L197.583 207.088L205.296 215.729L214.693 224.133L225.772 232.303L238.533 240.232L252.971 247.93L269.093 255.39L286.901 262.614L306.389 269.604L327.555 276.355",
    stroke: "url(#paint77_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M138.702 175.151L139.776 174.666L144.236 172.666L147.482 171.206L150.482 169.86L151.802 168.964L153.893 167.756L157.133 165.886L160.389 164.006L163.625 162.138L165.721 160.928L167.157 160.233L169.818 158.309L172.71 156.226L176.672 153.364L177.629 152.677",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M138.702 175.151L139.776 174.666L144.236 172.666L147.482 171.206L150.482 169.86L151.802 168.964L153.893 167.756L157.133 165.886L160.389 164.006L163.625 162.138L165.721 160.928L167.157 160.233L169.818 158.309L172.71 156.226L176.672 153.364L177.629 152.677",
    stroke: "url(#paint78_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M126.276 179.091L125.924 179.181L125.275 179.293L124.517 179.451L122.978 179.764L121.335 180.101L121.31 180.104L121.288 180.112L121.181 180.356L120.585 180.7L108.252 183.227L94.6102 184.215L82.1116 183.226L71.1343 180.285L62.0152 175.481L55.0303 168.967L50.3911 160.931L48.2396 151.621L48.6387 141.322L51.5824 130.348L56.9734 119.026L64.6494 107.706L74.3867 96.7273L85.8765 86.4293L98.7766 77.1224L112.695 69.0864L127.205 62.5681L141.869 57.7666L156.241 54.8255L169.886 53.8355L182.387 54.828L193.362 57.7653L202.482 62.5694L209.465 69.0901L214.104 77.1254L216.257 86.4294L215.858 96.7288L212.917 107.706L207.523 119.024L199.843 130.347L192.932 137.174L191.039 139.61L190.896 140.106L190.159 141.268L190.11 141.323L187.923 143.203L187.513 143.591L187.249 143.888L185.596 145.369L183.17 147.543L182.951 147.74L180.883 149.594L178.62 151.621L178.337 151.828L175.563 153.827L172.658 155.923L171.411 156.826L169.735 158.035L166.955 160.21L165.633 161.113L164.983 162.498L153.53 169.11L152.005 168.981L150.558 169.677L147.289 170.994L145.403 171.841L143.998 172.47L140.726 173.94L137.612 175.34L137.291 175.482L134.405 176.429L131.761 177.294L131.485 177.384L128.385 178.4L126.276 179.091ZM126.276 179.091L125.924 179.181L125.421 179.37L122.628 180.284L121.181 180.356L120.68 180.232L117.698 180.846L108.252 183.227L98.3099 186.947L81.962 188.132L66.9893 186.944L53.8382 183.42L42.913 177.666L34.5435 169.861L28.9853 160.234L26.4106 149.083L26.8896 136.744L30.4134 123.593L36.8708 110.032L46.0738 96.4713L57.7321 83.3197L71.4989 70.9817L86.9545 59.8286L103.63 50.2013L121.012 42.3952L138.585 36.6395L155.803 33.1189L172.145 31.9317L187.122 33.1174L200.273 36.6412L211.198 42.3959L219.563 50.2034L225.122 59.8304L227.7 70.9788L227.221 83.3176L223.697 96.4688L217.236 110.032L208.039 123.594L196.379 136.742L189.546 142.868L189.52 142.889L187.793 144.439L187.71 144.509L184.06 147.782L182.988 148.745L182.608 149.082L179.585 151.263L178.352 152.152L177.629 152.677L175.595 154.84L171.988 157.444L170.1 158.808L164.983 162.498L164.941 164.94L165.599 168.257L166.956 172.449L169.009 177.512L171.758 183.447L175.209 190.261L179.353 197.943L184.199 206.503L189.739 215.931L195.98 226.239L202.915 237.413L210.552 249.467L218.885 262.392L227.914 276.189L237.642 290.861L248.069 306.408L259.192 322.826L271.014 340.12",
    stroke: "#D9D9D9",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M126.276 179.091L125.924 179.181L125.275 179.293L124.517 179.451L122.978 179.764L121.335 180.101L121.31 180.104L121.288 180.112L121.181 180.356L120.585 180.7L108.252 183.227L94.6102 184.215L82.1116 183.226L71.1343 180.285L62.0152 175.481L55.0303 168.967L50.3911 160.931L48.2396 151.621L48.6387 141.322L51.5824 130.348L56.9734 119.026L64.6494 107.706L74.3867 96.7273L85.8765 86.4293L98.7766 77.1224L112.695 69.0864L127.205 62.5681L141.869 57.7666L156.241 54.8255L169.886 53.8355L182.387 54.828L193.362 57.7653L202.482 62.5694L209.465 69.0901L214.104 77.1254L216.257 86.4294L215.858 96.7288L212.917 107.706L207.523 119.024L199.843 130.347L192.932 137.174L191.039 139.61L190.896 140.106L190.159 141.268L190.11 141.323L187.923 143.203L187.513 143.591L187.249 143.888L185.596 145.369L183.17 147.543L182.951 147.74L180.883 149.594L178.62 151.621L178.337 151.828L175.563 153.827L172.658 155.923L171.411 156.826L169.735 158.035L166.955 160.21L165.633 161.113L164.983 162.498L153.53 169.11L152.005 168.981L150.558 169.677L147.289 170.994L145.403 171.841L143.998 172.47L140.726 173.94L137.612 175.34L137.291 175.482L134.405 176.429L131.761 177.294L131.485 177.384L128.385 178.4L126.276 179.091ZM126.276 179.091L125.924 179.181L125.421 179.37L122.628 180.284L121.181 180.356L120.68 180.232L117.698 180.846L108.252 183.227L98.3099 186.947L81.962 188.132L66.9893 186.944L53.8382 183.42L42.913 177.666L34.5435 169.861L28.9853 160.234L26.4106 149.083L26.8896 136.744L30.4134 123.593L36.8708 110.032L46.0738 96.4713L57.7321 83.3197L71.4989 70.9817L86.9545 59.8286L103.63 50.2013L121.012 42.3952L138.585 36.6395L155.803 33.1189L172.145 31.9317L187.122 33.1174L200.273 36.6412L211.198 42.3959L219.563 50.2034L225.122 59.8304L227.7 70.9788L227.221 83.3176L223.697 96.4688L217.236 110.032L208.039 123.594L196.379 136.742L189.546 142.868L189.52 142.889L187.793 144.439L187.71 144.509L184.06 147.782L182.988 148.745L182.608 149.082L179.585 151.263L178.352 152.152L177.629 152.677L175.595 154.84L171.988 157.444L170.1 158.808L164.983 162.498L164.941 164.94L165.599 168.257L166.956 172.449L169.009 177.512L171.758 183.447L175.209 190.261L179.353 197.943L184.199 206.503L189.739 215.931L195.98 226.239L202.915 237.413L210.552 249.467L218.885 262.392L227.914 276.189L237.642 290.861L248.069 306.408L259.192 322.826L271.014 340.12",
    stroke: "url(#paint79_linear_3463_43230)",
    strokeWidth: 0.755783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3463_43230",
    x1: 100.843,
    y1: 196.568,
    x2: 56.45,
    y2: 119.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3463_43230",
    x1: 106.95,
    y1: 193.441,
    x2: 57.5706,
    y2: 107.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3463_43230",
    x1: 212.045,
    y1: 352.877,
    x2: 128.545,
    y2: 208.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3463_43230",
    x1: 96.0691,
    y1: 198.561,
    x2: 57.2295,
    y2: 131.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3463_43230",
    x1: 287.004,
    y1: 276.595,
    x2: 222.013,
    y2: 164.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3463_43230",
    x1: 285.438,
    y1: 318.757,
    x2: 198.364,
    y2: 167.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3463_43230",
    x1: 292.86,
    y1: 260.571,
    x2: 259.434,
    y2: 202.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3463_43230",
    x1: 89.8177,
    y1: 199.764,
    x2: 57.4924,
    y2: 143.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3463_43230",
    x1: 280.74,
    y1: 327.885,
    x2: 178.748,
    y2: 151.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3463_43230",
    x1: 277.096,
    y1: 334.379,
    x2: 172.549,
    y2: 153.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3463_43230",
    x1: 279.094,
    y1: 255.682,
    x2: 239.082,
    y2: 186.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3463_43230",
    x1: 87.6948,
    y1: 199.511,
    x2: 61.5674,
    y2: 154.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3463_43230",
    x1: 274.351,
    y1: 245.778,
    x2: 244.201,
    y2: 193.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3463_43230",
    x1: 89.2902,
    y1: 198.585,
    x2: 68.6373,
    y2: 162.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3463_43230",
    x1: 271.512,
    y1: 235.36,
    x2: 252.953,
    y2: 203.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3463_43230",
    x1: 92.1089,
    y1: 196.598,
    x2: 76.835,
    y2: 170.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3463_43230",
    x1: 231.78,
    y1: 362.771,
    x2: 122.278,
    y2: 173.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3463_43230",
    x1: 265.596,
    y1: 227.659,
    x2: 254.015,
    y2: 207.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3463_43230",
    x1: 94.9725,
    y1: 193.499,
    x2: 85.1381,
    y2: 176.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3463_43230",
    x1: 159.838,
    y1: 324.535,
    x2: 133.492,
    y2: 278.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3463_43230",
    x1: 214.119,
    y1: 129.674,
    x2: 181.068,
    y2: 72.4281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3463_43230",
    x1: 259.399,
    y1: 221.405,
    x2: 253.622,
    y2: 211.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3463_43230",
    x1: 100.913,
    y1: 190.069,
    x2: 95.3363,
    y2: 180.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3463_43230",
    x1: 196.415,
    y1: 142.207,
    x2: 142.597,
    y2: 48.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3463_43230",
    x1: 114.447,
    y1: 189.53,
    x2: 60.6287,
    y2: 96.3147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3463_43230",
    x1: 211.189,
    y1: 126.869,
    x2: 201.152,
    y2: 109.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3463_43230",
    x1: 152.42,
    y1: 293.001,
    x2: 142.588,
    y2: 275.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3463_43230",
    x1: 243.588,
    y1: 331.835,
    x2: 179.477,
    y2: 220.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3463_43230",
    x1: 289.269,
    y1: 287.343,
    x2: 210.34,
    y2: 150.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3463_43230",
    x1: 161.15,
    y1: 189.571,
    x2: 148.294,
    y2: 167.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3463_43230",
    x1: 288.475,
    y1: 308.751,
    x2: 204.863,
    y2: 163.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3463_43230",
    x1: 235.23,
    y1: 313.82,
    x2: 185.398,
    y2: 227.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3463_43230",
    x1: 152.612,
    y1: 304.007,
    x2: 137.966,
    y2: 278.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3463_43230",
    x1: 215.315,
    y1: 128.211,
    x2: 188.157,
    y2: 81.1716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3463_43230",
    x1: 149.88,
    y1: 165.989,
    x2: 108.514,
    y2: 94.3407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3463_43230",
    x1: 151.642,
    y1: 163.215,
    x2: 129.161,
    y2: 124.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3463_43230",
    x1: 159.577,
    y1: 176.709,
    x2: 153.337,
    y2: 165.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3463_43230",
    x1: 155.966,
    y1: 314.128,
    x2: 135.344,
    y2: 278.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3463_43230",
    x1: 157.961,
    y1: 168.97,
    x2: 155.699,
    y2: 165.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3463_43230",
    x1: 245.183,
    y1: 352.804,
    x2: 142.847,
    y2: 175.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3463_43230",
    x1: 159.031,
    y1: 172.048,
    x2: 154.781,
    y2: 164.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3463_43230",
    x1: 167.444,
    y1: 332.98,
    x2: 134.018,
    y2: 275.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3463_43230",
    x1: 163.379,
    y1: 162.279,
    x2: 99.9103,
    y2: 52.3482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3463_43230",
    x1: 153.413,
    y1: 168.033,
    x2: 89.9444,
    y2: 58.1017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3463_43230",
    x1: 211.704,
    y1: 131.8,
    x2: 172.864,
    y2: 64.5277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3463_43230",
    x1: 252.322,
    y1: 350.912,
    x2: 146.542,
    y2: 167.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3463_43230",
    x1: 174.657,
    y1: 200.652,
    x2: 153.385,
    y2: 163.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3463_43230",
    x1: 172.488,
    y1: 157.02,
    x2: 109.985,
    y2: 48.7608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3463_43230",
    x1: 142.867,
    y1: 174.122,
    x2: 80.3639,
    y2: 65.8633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3463_43230",
    x1: 205.517,
    y1: 252.373,
    x2: 193.338,
    y2: 231.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3463_43230",
    x1: 154.575,
    y1: 164.123,
    x2: 146.878,
    y2: 150.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3463_43230",
    x1: 235.059,
    y1: 354.259,
    x2: 141.461,
    y2: 192.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_3463_43230",
    x1: 132.693,
    y1: 179.846,
    x2: 72.1557,
    y2: 74.9921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_3463_43230",
    x1: 181.182,
    y1: 151.85,
    x2: 120.645,
    y2: 46.9964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_3463_43230",
    x1: 199.022,
    y1: 239.661,
    x2: 190.688,
    y2: 225.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_3463_43230",
    x1: 214.959,
    y1: 127.745,
    x2: 193.564,
    y2: 90.6874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_3463_43230",
    x1: 150.939,
    y1: 164.706,
    x2: 119.203,
    y2: 109.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_3463_43230",
    x1: 156.994,
    y1: 165.149,
    x2: 155.377,
    y2: 162.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_3463_43230",
    x1: 192.9,
    y1: 228.017,
    x2: 187.207,
    y2: 218.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_3463_43230",
    x1: 153.73,
    y1: 164.54,
    x2: 138.384,
    y2: 137.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_3463_43230",
    x1: 201.227,
    y1: 349.291,
    x2: 126.203,
    y2: 219.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_3463_43230",
    x1: 182.239,
    y1: 337.08,
    x2: 126.865,
    y2: 241.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_3463_43230",
    x1: 185.978,
    y1: 218.102,
    x2: 167.243,
    y2: 185.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_3463_43230",
    x1: 191.309,
    y1: 343.901,
    x2: 126.267,
    y2: 231.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_3463_43230",
    x1: 175.697,
    y1: 211.411,
    x2: 154.423,
    y2: 174.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_3463_43230",
    x1: 123.097,
    y1: 184.961,
    x2: 65.5234,
    y2: 85.2417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_3463_43230",
    x1: 189.184,
    y1: 146.806,
    x2: 131.611,
    y2: 47.0859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_3463_43230",
    x1: 170.508,
    y1: 192.975,
    x2: 153.819,
    y2: 164.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_3463_43230",
    x1: 219.629,
    y1: 280.971,
    x2: 196.454,
    y2: 240.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_3463_43230",
    x1: 206.177,
    y1: 129.295,
    x2: 200.6,
    y2: 119.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_3463_43230",
    x1: 202.722,
    y1: 138.146,
    x2: 153.343,
    y2: 52.6194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_3463_43230",
    x1: 227.242,
    y1: 296.865,
    x2: 193.118,
    y2: 237.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_3463_43230",
    x1: 223.441,
    y1: 354.552,
    x2: 131.868,
    y2: 195.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_3463_43230",
    x1: 213.299,
    y1: 127.618,
    x2: 197.597,
    y2: 100.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_3463_43230",
    x1: 212.39,
    y1: 266.142,
    x2: 175.389,
    y2: 202.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_3463_43230",
    x1: 161.726,
    y1: 181.716,
    x2: 154.053,
    y2: 168.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_3463_43230",
    x1: 207.898,
    y1: 134.76,
    x2: 163.505,
    y2: 57.8688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_3463_43230",
    x1: 289.769,
    y1: 298.172,
    x2: 199.659,
    y2: 142.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_3463_43230",
    x1: 156.705,
    y1: 166.267,
    x2: 156.051,
    y2: 165.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_3463_43230",
    x1: 252.322,
    y1: 350.912,
    x2: 84.9368,
    y2: 60.9935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B350CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DD4FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGraphic);
export default __webpack_public_path__ + "static/media/profile-graphic.1ceeb72cb21ba05c132db01584240458.svg";
export { ForwardRef as ReactComponent };